import type { ReactNode } from 'react';

export const symbol_speaker: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M700-80H260q-24.75 0-42.37-17.63Q200-115.25 200-140v-680q0-24.75 17.63-42.38Q235.25-880 260-880h440q24.75 0 42.38 17.62Q760-844.75 760-820v680q0 24.75-17.62 42.37Q724.75-80 700-80Zm0-60v-680H260v680h440ZM535-626q22-22 22-54t-22-54q-22-22-54-22t-54 22q-22 22-22 54t22 54q22 22 54 22t54-22Zm61.5 382.5Q644-291 644-360t-47.5-116.5Q549-524 480-524t-116.5 47.5Q316-429 316-360t47.5 116.5Q411-196 480-196t116.5-47.5Zm-190-43.07q-30.5-30.57-30.5-73.5t30.57-73.43q30.57-30.5 73.5-30.5t73.43 30.57q30.5 30.57 30.5 73.5t-30.57 73.43q-30.57 30.5-73.5 30.5t-73.43-30.57ZM260-820v680-680Z"
		/>
	</svg>
);
